module.exports = __webpack_public_path__ + "static/profile-c84088f8bc06897e075a7fba626380a7.png";